export default __webpack_public_path__ + "static/media/icon-error-fill.58b2137a.svg";